import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { StepRunProgress } from '../workflows/StepRunProgress.js';
import { OnboardingShell } from './OnboardingShell.js';

const SUPPORT_EMAIL = 'csm@alison.ai';

// The progress card workflows show while they run.
const SETUP_STEPS = [
  'Ad networks connected',
  'Checking access to your ad accounts',
  'Pulling your ads and building your insights',
];

export function DonePage({
  email,
  onSignOut,
}: {
  email: string | null;
  onSignOut: () => void;
}): ReactNode {
  return (
    <OnboardingShell
      email={email}
      onSignOut={onSignOut}
      step="setup"
      title="You're all set. We're on it!"
      subtitle="Alison is checking access, pulling your ads and tagging every creative. Nothing for you to do."
      note={
        email === null
          ? `Your first insights will land in your inbox, usually within a few days. Questions? ${SUPPORT_EMAIL}`
          : `Your first insights will land at ${email}, usually within a few days. Questions? ${SUPPORT_EMAIL}`
      }
    >
      <Box data-testid="onboarding-done">
        <StepRunProgress runningTitle="Setting up your workspace" runningSteps={SETUP_STEPS} />
      </Box>
    </OnboardingShell>
  );
}
